import React, { useEffect, useMemo } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { twMerge } from 'tailwind-merge';
import { LexicalUtils } from '@components/Lexical/utils';
import ProgressCircle from '@components/ProgressCircle';

export function CharacterCountPlugin({ maxLength }: { maxLength: number }) {
  const [textLength, setTextLength] = React.useState(0);

  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }) => {
      const count = LexicalUtils.getNodeTextLength(LexicalUtils.getRootNode(editorState));
      setTextLength(count);
    });
  }, [editor]);

  const [isTextTooLong, progressPercent] = useMemo(
    () => [textLength > maxLength, Math.min((textLength / maxLength) * 100, 100)],
    [textLength, maxLength],
  );

  return (
    <div
      className={`bg absolute bottom-2 right-2 -mx-2 -my-1 flex select-none items-center gap-1 overflow-hidden rounded-full px-2 py-1 backdrop-blur ${
        isTextTooLong ? `bg-destructive50/50` : `bg-neutral100/50`
      }`}
    >
      <div
        className={twMerge(
          `text-base-s`,
          isTextTooLong ? `text-destructive400` : `text-neutral400`,
        )}
      >
        {textLength}/{maxLength}
      </div>
      <ProgressCircle
        percent={progressPercent}
        size={16}
        remainingColor="#E6E6E6"
        usedColor={isTextTooLong ? '#D22F2F' : '#0e1213'}
      />
    </div>
  );
}
